import s from './Bundles.module.scss';
import useGetBundlesBySalonId from 'sdk/hooks/salon/useGetBundlesBySalonId';
import { useParams } from 'react-router-dom';
import BundleCard from './BundleCard';
import { AppointmentBookingSteps } from 'modules/feed/components/Feed/Post/AppointmentBooking/AppointmentBooking';

type Props = {
  salonId: string;
}

const Bundles = ({salonId}: Props) => {
  const { id } = useParams();
  const { data: bundles } = useGetBundlesBySalonId(salonId || id);

  if (!bundles?.length) {
    return (
      <div className={s.bundles_container} style={{ textAlign: 'center' }}>
        No bundles found
      </div>
    );
  }

  return (
    <div className={s.bundles_container}>
      {bundles?.map(bundle => (
        <BundleCard key={bundle.id} bundle={bundle as any} salonId={salonId} />
      ))}
    </div>
  );
};
export default Bundles;
